import type { EmployerSiteName } from 'src/types';
import {
  shouldRenderMultiLocationInSite,
  shouldRenderMultiLocationInJobLocationCountry,
} from 'src/utils/shouldRenderMultiLocation';

import { JobAction } from '../type';
import type { JobActionMenuOption } from '../useJobActionMenuOptions';

export const filterJobActionMenuOptions = (
  options: JobActionMenuOption[],
  {
    jobLocationCountry,
    siteName,
  }: { jobLocationCountry?: string; siteName: EmployerSiteName },
) => {
  const isMultiLocationEnabledForJob =
    shouldRenderMultiLocationInSite(siteName) &&
    shouldRenderMultiLocationInJobLocationCountry(jobLocationCountry);

  return options.filter(
    (action) =>
      action.value !== JobAction.MULTI_LOCATION || isMultiLocationEnabledForJob,
  );
};
